import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatUtilityNavItem } from '@blocks-react/components/UtilityNavItem';
import cx from 'classnames';
import styles from './HeaderNavItem.module.scss';

type HeaderNavItemProps = ComponentProps<typeof CatUtilityNavItem> & {
  classname?: string;
};

export const HeaderNavItem: FC<PropsWithChildren<HeaderNavItemProps>> = ({
  children,
  classname,
  ...props
}) => {
  return (
    <CatUtilityNavItem {...props} hideText>
      <div
        slot="before"
        className={cx(classname ?? '', styles['header__nav-item'])}
      >
        {children}
      </div>
    </CatUtilityNavItem>
  );
};
